// extracted by mini-css-extract-plugin
export default {"header":"HeaderTitle_header__8YicI","header_sub_container":"HeaderTitle_header_sub_container__mEZfJ","tab":"HeaderTitle_tab__HAGdQ","text":"HeaderTitle_text__s8OUb"};